var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "viq-tl-event",
      class: { "viq-tl-event--last": _vm.isLast },
    },
    [
      _c("div", {
        staticClass: "viq-tl-event__dot",
        class: "viq-tl-event__dot--" + _vm.statusClass,
      }),
      _vm._v(" "),
      _c("div", { staticClass: "viq-tl-event__card" }, [
        _c("div", { staticClass: "viq-tl-event__date" }, [
          _vm._v(_vm._s(_vm.formatDate(_vm.event.date))),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "viq-tl-event__title" }, [
          _vm._v(_vm._s(_vm.event.title || _vm.event.description)),
        ]),
        _vm._v(" "),
        _vm.event.description && _vm.event.title
          ? _c("p", { staticClass: "viq-tl-event__desc" }, [
              _vm._v("\n      " + _vm._s(_vm.event.description) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "viq-tl-event__meta" }, [
          _vm.event.status
            ? _c(
                "span",
                {
                  staticClass: "viq-tl-event__status",
                  class: "viq-tl-event__status--" + _vm.statusClass,
                },
                [_vm._v("\n        " + _vm._s(_vm.event.status) + "\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.event.jurisdiction
            ? _c("span", { staticClass: "viq-tl-event__jurisdiction" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.event.jurisdiction) + "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.event.type
            ? _c("span", { staticClass: "viq-tl-event__type" }, [
                _vm._v(_vm._s(_vm.event.type)),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }